import React, { useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Volume2, VolumeX } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export default function MediaCarousel({ media = [], className = "", heightClass = "aspect-square", contain = false, testid = "media-carousel" }) {
  const [idx, setIdx] = useState(0);
  const [muted, setMuted] = useState(true);
  const startX = useRef(null);
  const list = media && media.length ? media : [];

  if (!list.length) {
    return (
      <div className={`${heightClass} w-full bg-[#141414] flex items-center justify-center ${className}`}>
        <img src="/logo_wide.webp" alt="" className="w-1/2 opacity-20" />
      </div>
    );
  }

  const go = (n) => setIdx((prev) => (n + list.length) % list.length);
  const onTouchStart = (e) => { startX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (startX.current == null) return;
    const dx = e.changedTouches[0].clientX - startX.current;
    if (dx > 40) go(idx - 1);
    else if (dx < -40) go(idx + 1);
    startX.current = null;
  };

  const cur = list[idx];
  const isVideo = cur.kind === "video" || (cur.content_type || "").startsWith("video");
  const fit = contain ? "object-contain" : "object-cover";

  return (
    <div className={`relative ${heightClass} w-full overflow-hidden bg-black ${className}`} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} data-testid={testid}>
      {isVideo ? (
        <video
          key={cur.path}
          src={mediaUrl(cur)}
          className={`w-full h-full ${fit}`}
          autoPlay muted={muted} loop playsInline
          onClick={() => setMuted((m) => !m)}
          data-testid="carousel-video"
        />
      ) : (
        <img src={mediaUrl(cur)} alt="" className={`w-full h-full ${fit}`} data-testid="carousel-image" />
      )}

      {isVideo && (
        <button onClick={() => setMuted((m) => !m)} className="absolute bottom-2 right-2 bg-black/60 text-white rounded-full p-2 z-10" data-testid="carousel-mute-btn">
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>
      )}

      {list.length > 1 && (
        <>
          <button onClick={(e) => { e.stopPropagation(); go(idx - 1); }} className="absolute left-1 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-[#E60000] text-white rounded-full p-1.5 transition-colors z-10" data-testid="carousel-prev">
            <ChevronLeft size={20} />
          </button>
          <button onClick={(e) => { e.stopPropagation(); go(idx + 1); }} className="absolute right-1 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-[#E60000] text-white rounded-full p-1.5 transition-colors z-10" data-testid="carousel-next">
            <ChevronRight size={20} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
            {list.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-4 bg-[#E60000]" : "w-1.5 bg-white/50"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
